import { render, staticRenderFns } from "./DisqualificationDestoryConfirmTable.vue?vue&type=template&id=56e91592&scoped=true"
import script from "./DisqualificationDestoryConfirmTable.vue?vue&type=script&lang=js"
export * from "./DisqualificationDestoryConfirmTable.vue?vue&type=script&lang=js"
import style0 from "./DisqualificationDestoryConfirmTable.vue?vue&type=style&index=0&id=56e91592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e91592",
  null
  
)

export default component.exports